module.exports = __webpack_public_path__ + "static/img/flow.6a57806.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/subscription/flow.png
// module id = ffK4
// module chunks = 6